export default __webpack_public_path__ + "static/media/prawojazdy.pro-background.209f486c.png";